import { useState, useEffect } from 'react';
import { useApi } from '../hooks/useApi';

// QUÉ TIENE HABILITADO EL BOLICHE SEGÚN SU PLAN.
//
// El que manda es el servidor (planes.js): ahí se frena de verdad. Esto es sólo para que
// el panel muestre el candado antes de que el dueño entre a una sección y se encuentre un
// error. Se pide una vez y se comparte entre el menú, las pestañas del evento y la
// administración; al cambiar de plan se vuelve a pedir.

let cache = null;
let enCurso = null;
const subs = new Set();

function pedir(api) {
  if (!enCurso) {
    enCurso = api.get('/api/billing/resumen')
      .then(r => { cache = r; subs.forEach(fn => fn(r)); return r; })
      .catch(() => null)
      .finally(() => { enCurso = null; });
  }
  return enCurso;
}

export function usePlan() {
  const api = useApi();
  const [r, setR] = useState(cache);
  useEffect(() => {
    subs.add(setR);
    if (!cache) pedir(api);
    return () => { subs.delete(setR); };
  }, []); // eslint-disable-line
  return r;
}

export function refrescarPlan(api) { cache = null; return pedir(api); }

// ¿Está habilitada? Mientras no se sabe, se asume que sí: mejor un error del servidor
// en el peor caso que un candado que parpadea en cada carga.
export const habilitada = (plan, funcion) => !plan || plan.funciones?.[funcion]?.habilitada !== false;

const NOMBRE = { basico: 'Básico', pro: 'Pro', full: 'Full' };

export function EtiquetaPlan({ plan, funcion }) {
  if (habilitada(plan, funcion)) return null;
  const req = plan.funciones[funcion].requiere;
  return (
    <span style={{ marginLeft: 6, fontSize: 9, letterSpacing: '0.08em', padding: '1px 5px', borderRadius: 3, border: '1px solid rgba(236,38,143,0.5)', color: '#EC268F', verticalAlign: 'middle' }}>
      {NOMBRE[req].toUpperCase()}
    </span>
  );
}

export function PlanBloqueado({ plan, funcion, onVerPlanes }) {
  const f = plan.funciones[funcion];
  return (
    <div className="lb-card" style={{ maxWidth: 540, padding: '26px 26px 22px', marginTop: 8 }}>
      <div className="lb-eyebrow" style={{ color: '#EC268F', marginBottom: 6 }}>Plan {NOMBRE[f.requiere]}</div>
      <div className="lb-h" style={{ fontSize: 19 }}>{f.etiqueta}</div>
      <p style={{ fontSize: 13.5, color: 'var(--ink-700)', lineHeight: 1.6, margin: '10px 0 18px' }}>
        Esta sección es del plan <b style={{ color: '#fff' }}>{NOMBRE[f.requiere]}</b> y tu plan es <b style={{ color: '#fff' }}>{NOMBRE[plan.plan] || plan.plan}</b>.
        Si subís, se habilita al instante.
      </p>
      {onVerPlanes && <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={onVerPlanes}>Ver planes</button>}
    </div>
  );
}
